// extracted by mini-css-extract-plugin
export default {"featureListContainer":"FeatureList_common_featureListContainer__Zo4GV","successIcon":"FeatureList_common_successIcon__muVvu","featureItem":"FeatureList_common_featureItem__zKhoE"};